import { importPageParamsSchemaValidator } from "@grafit/shared/utils/sidebar-url-params-schema";
import { createFileRoute } from "@tanstack/react-router";
import { BidLinkPage } from "../../../../../pages/bid-link-page/bid-link-page";

export const Route = createFileRoute("/_auth/_deal/deals/$dealId/import_/$subProjectId/link")({
  component: BidLinkPage,
  validateSearch: importPageParamsSchemaValidator,
});
